/** @jsx jsx */
/** @jsxFrag */
import { ClassNames, jsx } from '@emotion/react';
import ButtonLink from 'components/ButtonLink';
import Dialog from 'components/Dialog';
import VideoComponent from 'components/VideoComponent';
import React, { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';
import fixMediaPath from 'server/fixMediaPath';
import { CompanyReference } from 'types/Reference';

export interface ReferenceListCardProps extends React.HTMLAttributes<HTMLDivElement> {
  reference: CompanyReference;
}

const ReferenceListCard: React.FC<ReferenceListCardProps> = ({ reference }) => {
  const [openVideoDialog, setopenVideoDialog] = React.useState<boolean>(false);
  const handleClick = React.useCallback<MouseEventHandler>((event) => {
    event.preventDefault();
    setopenVideoDialog(true);
  }, []);
  return (
    <ClassNames>
      {({ theme }) => (
        <div
          css={{
            background: '#FFF',
            border: '1px solid #CCC',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
          }}
        >
          <div css={{ alignItems: 'center', display: 'flex', height: '60px' }}>
            <img
              css={{ alignSelf: 'center', marginLeft: '20px', maxHeight: '60px', maxWidth: '200px', width: 'auto' }}
              src={reference.logo}
              alt=''
            />
          </div>
          <p css={{ color: theme.palette.primary.dark, fontWeight: 500, margin: '40px 0 40px 20px' }}>
            {reference.text}
          </p>
          <div
            css={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 'auto',
              maxHeight: '40px',
              width: '100%',
            }}
          >
            {reference.caseStudy && (
              <ButtonLink
                to={fixMediaPath(reference.caseStudy)}
                css={{
                  '&:hover': { boxShadow: theme.shadows[6], svg: { display: 'none' } },
                  svg: { display: 'none' },
                  width: '47%',
                }}
                isExternal
              >
                <FormattedMessage id={'btn.casestudy'} />
              </ButtonLink>
            )}
            {reference.video && (
              <ButtonLink
                onClick={handleClick}
                css={{
                  '&:hover': { boxShadow: theme.shadows[6], svg: { display: 'none' } },
                  svg: { display: 'none' },
                  width: '47%',
                }}
              >
                <FormattedMessage id={'btn.video'} />
              </ButtonLink>
            )}
          </div>
          {openVideoDialog && reference.video && (
            <Dialog onClose={() => setopenVideoDialog(false)}>
              <VideoComponent stream={reference.video} videoOpts={{ playerVars: { autoplay: 1 } }} />
            </Dialog>
          )}
        </div>
      )}
    </ClassNames>
  );
};
export default ReferenceListCard;
